import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Renderer2, inject } from '@angular/core';
import { BasketFreeDeliveryNoticeComponentDef } from '@df/basket/free-shipping/basket-free-delivery-notice.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'basket-free-shipping',
    templateUrl: './basket-free-shipping.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, CommonModule, SizeClassDirective]
})
export class BasketFreeDeliveryNoticeComponent extends BasketFreeDeliveryNoticeComponentDef {
    /**
     * Renderer service
     */
    private renderer2 = inject(Renderer2);

    override ngOnInit(): void {
        super.ngOnInit();
        this.detectChanges();
    }
    /**
     * Only make element visible when any rules apply
     */
    override detectChanges(): void {
        super.detectChanges();
        (this.rules?.length || 0) > 0
            ? this.renderer2.removeClass(this.elementRef.nativeElement, 'ng-hide')
            : this.renderer2.addClass(this.elementRef.nativeElement, 'ng-hide');
    }
}
